import React, { useState, useEffect, useRef } from "react";
import "./classes/CompanySetup.css";
import "./classes/Main.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAddressCard, faIndustry, faBriefcase, faFileInvoice, faPhone, faMoneyCheck, faLandmark, faMoneyCheckAlt } from "@fortawesome/free-solid-svg-icons";
import { Helmet } from "react-helmet";
import { configData } from "../config";
import { useLocation, useParams } from "react-router-dom";

const EditCompanySetup = () => {

    const { id } = useParams(); 
    //const id = localStorage.getItem("company_id");

    const initialForm = {
        company_name:'',
        gst_number:'',
        phone:'',
        company_address:'',
        bank_name:'',
        account_number:'',
        ifs_code: '',
        bank_branch: ''
    };

    const API_BASE = configData.APP_URL;
    const location = useLocation();
    const className = location.state?.from === "protected-route" ? "pos-common-main" : "";

    const [formData, setFormData] = useState(initialForm);
    const [submitting, setSubmitting] = useState(false);
    const [loading, setLoading] = useState(true);
    const [company, setCompany] = useState(true);

      useEffect(() => {
    const fetchCompany = async () => {
      try {
        const res = await fetch(`${API_BASE}companyapi/list?company_id=${id}`);
        const data = await res.json();

        if (data.success && data.company) {
          setFormData(data.company);
        } else {
          alert("Company not found");
        }
      } catch (err) {
        console.error(err);
        alert("Error fetching company");
      } finally {
        setLoading(false);
      }
    };

    if (id) fetchCompany();
  }, [id]);
    const companydetails = async () => {
      try {
        const res = await fetch(API_BASE + "salesapi/showcom");
        const data = await res.json();
    
        if (data.company) {
          setFormData(data.company);
          setCompany(data.company);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
  
    useEffect(() => {
        companydetails();
    }, []);
  
    // if (!companyDetail) return;

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const isValidPhone = (phone) => {
        return /^(\+91[\-\s]?)?[0]?[6-9]\d{9}$/.test(phone);
    };

    const isValidGST = (gst) => {
        if (!gst) return false; 

        gst = gst.trim().toUpperCase(); 

        // Regex for GSTIN
        const gstRegex = /^[0-3][0-9][A-Z0-9]{13}$/;
        return gstRegex.test(gst);
    };

     const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.company_name.trim())
      return alert("Company name is required");

    if (!formData.gst_number.trim())
      return alert("GST Number is required");

    if (!isValidGST(formData.gst_number))
      return alert("Invalid GST Number");

    if (!formData.phone.trim())
      return alert("Phone is required");

    if (!isValidPhone(formData.phone))
      return alert("Invalid phone number");

    if (!formData.company_address.trim())
      return alert("Address is required");

    setSubmitting(true);

    try {
      const res = await fetch(`${API_BASE}companyapi/update?company_id=${company.company_id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData)
      });

      const data = await res.json();

      if (!res.ok) throw new Error(data.message || "Update failed");

      alert("Company updated successfully");

    } catch (err) {
      console.error(err);
      alert(err.message);
    } finally {
      setSubmitting(false);
    }
  };
//     if (loading) {
//     return <div className="main">Loading company...</div>;
//   }

    return (
        <div className={className}>
            <div className="company-setup-main">
                <Helmet>
                    <title>Edit Company Setup</title>
                </Helmet>
                <div className="main">
                    <div className="columns">
                        <div className="cs-left-container">
                            <h2>Edit Company Setup</h2>
                            <div className="login-form-field">
                                <label htmlFor="company_name">Company Name</label>
                                <div className="login-input-container">
                                    <span className="login-input-icon-container">
                                        <FontAwesomeIcon icon={faIndustry} />
                                    </span>
                                    <input
                                        type="text"
                                        name="company_name"
                                        value={formData.company_name}
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>

                            <div className="login-form-field">
                                <label htmlFor="gst_number">GST Number</label>
                                <div className="login-input-container">
                                    <span className="login-input-icon-container">
                                        <FontAwesomeIcon icon={faFileInvoice} />
                                    </span>
                                    <input
                                        type="text"
                                        name="gst_number"
                                        value={formData.gst_number}
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>

                            <div className="login-form-field">
                                <label htmlFor="phone">Phone</label>
                                <div className="login-input-container">
                                    <span className="login-input-icon-container">
                                        <FontAwesomeIcon icon={faPhone} />
                                    </span>
                                    <input
                                        type="text"
                                        name="phone"
                                        value={formData.phone}
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>

                            <div className="login-form-field">
                                <label htmlFor="address">Address</label>
                                <div className="login-input-container">
                                    <span className="login-input-icon-container">
                                        <FontAwesomeIcon icon={faAddressCard} />
                                    </span>
                                    <input
                                        type="text"
                                        name="company_address"
                                        value={formData.company_address}
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="cs-left-container">
                            <h2>Bank Details</h2>

                            <div className="login-form-field">
                                <label htmlFor="bank_name">Bank Name</label>
                                <div className="login-input-container">
                                    <span className="login-input-icon-container">
                                        <FontAwesomeIcon icon={faBriefcase} />
                                    </span>
                                    <input
                                        type="text"
                                        name="bank_name"
                                        value={formData.bank_name}
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>

                            <div className="login-form-field">
                                <label htmlFor="account_number">Account Number</label>
                                <div className="login-input-container">
                                    <span className="login-input-icon-container">
                                        <FontAwesomeIcon icon={faMoneyCheckAlt} />
                                    </span>
                                    <input
                                        type="text"
                                        name="account_number"
                                        value={formData.account_number}
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>

                            <div className="login-form-field">
                                <label htmlFor="ifs_code">IFS Code</label>
                                <div className="login-input-container">
                                    <span className="login-input-icon-container">
                                        <FontAwesomeIcon icon={faMoneyCheck} />
                                    </span>
                                    <input
                                        type="text"
                                        name="ifs_code"
                                        value={formData.ifs_code}
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>

                            <div className="login-form-field">
                                <label htmlFor="bank_branch">Branch</label>
                                <div className="login-input-container">
                                    <span className="login-input-icon-container">
                                        <FontAwesomeIcon icon={faLandmark} />
                                    </span>
                                    <input
                                        type="text"
                                        name="bank_branch"
                                        value={formData.bank_branch}
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="form-actions">
                        <button className="login-form-submit" onClick={handleSubmit} disabled={submitting}>
                            {submitting ? "Saving..." : "Save Company"}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default EditCompanySetup;